export default "__VITE_ASSET__c97eb6de__"